import { render, staticRenderFns } from "./footerService.vue?vue&type=template&id=453af5d1&scoped=true&"
import script from "./footerService.vue?vue&type=script&lang=js&"
export * from "./footerService.vue?vue&type=script&lang=js&"
import style0 from "./footerService.vue?vue&type=style&index=0&id=453af5d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453af5d1",
  null
  
)

export default component.exports